import {
	ADD_DICTBUDGETTYPE,
	UPDATE_DICTBUDGETTYPE,
	DELETE_DICTBUDGETTYPE,
	GET_DICTBUDGETTYPE_LIST,
} from '../constant';
import {
	getDictBudgetTypesApi,
	addDictBudgetTypeApi,
	updateDictBudgetTypeApi,
	deleteDictBudgetTypeApi,
} from '../../api';

export const getDictBudgetTypes = (data) => ({
	type: GET_DICTBUDGETTYPE_LIST,
	data,
});

export const addDictBudgetType = (data) => ({
	type: ADD_DICTBUDGETTYPE,
	data,
});

export const updateDictBudgetType = (data) => ({
	type: UPDATE_DICTBUDGETTYPE,
	data,
});

export const deleteDictBudgetType = (data) => ({
	type: DELETE_DICTBUDGETTYPE,
	data,
});

export const getDictBudgetTypesAsync = (params) => {
	const pageSize = 15;
	params = { ...params, pageSize };
	return (dispatch) => {
		return getDictBudgetTypesApi(params)
			.then((data) => {
				if (data.errorCode.trim().length === 0) {
					const totalCount = (data.value as any)?.total ?? 0;
					const totalpage =
						parseInt(parseInt(totalCount) / pageSize + '') +
						(totalCount % pageSize > 0 ? 1 : 0);
					dispatch(
						getDictBudgetTypes({
							data: (data.value as any)?.data ?? [],
							total: totalpage,
						})
					);
				} else {
					console.error(`${data.errorCode}:: ${data.errorMessage}`);
				}
			})
			.catch((error) => {
				throw error;
			});
	};
};

export const addDictBudgetTypeAsync = (data) => async (dispatch) => {
	try {
		const response = await addDictBudgetTypeApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(addDictBudgetType(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateDictBudgetTypeAsync = (data) => async (dispatch) => {
	try {
		const response = await updateDictBudgetTypeApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(updateDictBudgetType(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteDictBudgetTypeAsync = (data) => async (dispatch) => {
	try {
		const response = await deleteDictBudgetTypeApi(data);
		if (response.errorCode.trim().length === 0) {
			dispatch(deleteDictBudgetType(response.value));

			return Promise.resolve(response.value);
		} else {
			return Promise.reject(response.errorMessage);
		}
	} catch (error) {
		return Promise.reject(error);
	}
};
